// カラーマスタ照会と、明細行への反映/クリアをまとめる。
// 本文は HinbanMaster.js から移設したもの。

export function createColorMasterService(deps) {
    const {
        DicVal,
        GridApi,
        dispatch,
        entrydata,
        entrydataRef,
        entryrerender,
        fnc,
        isEmpty,
        rerender,
        resolveItemMasterBrandCode,
        storeRowData
    } = deps;

    function applyColorMasterInfoToData(targetData, colorMasterInfo) {
        if (isEmpty(targetData) || isEmpty(colorMasterInfo)) return false;
        let updated = false;
        const mappings = [
            { key: "PDTC_COLORNM", value: DicVal(colorMasterInfo, "BCOL_BCOLORNM", "") },
            { key: "PDTC_COLOREJ", value: DicVal(colorMasterInfo, "BCOL_BCOLOREJ", "") },
            { key: "PDTC_COLORKANA", value: DicVal(colorMasterInfo, "BCOL_BCOLORKANA", "") }
        ];
        mappings.forEach((mapping) => {
            const nextValue = String(isEmpty(mapping.value) ? "" : mapping.value);
            if (String(DicVal(targetData, mapping.key, "")) === nextValue) return;
            targetData[mapping.key] = nextValue;
            updated = true;
        });
        return updated;
    }
    function clearColorMasterInfoOnData(targetData) {
        if (isEmpty(targetData)) return false;
        let updated = false;
        [
            "PDTC_COLORNM",
            "PDTC_COLOREJ",
            "PDTC_COLORKANA"
        ].forEach((key) => {
            if (!(key in targetData)) return;
            if (String(DicVal(targetData, key, "")) === "") return;
            targetData[key] = "";
            updated = true;
        });
        return updated;
    }
    function reflectColorMasterInfoChange(targetData, rowNode, panel) {
        if (isEmpty(targetData)) return;
        if (!isEmpty(rowNode)) {
            rowNode.setData({ ...targetData });
            if (!isEmpty(panel)) {
                setTimeout(() => storeRowData(panel), 0);
            }
            return;
        }
        if (!isEmpty(panel) && !isEmpty(targetData.rowid)) {
            const gridApi = GridApi(panel);
            if (!isEmpty(gridApi)) {
                const targetRowNode = gridApi.getRowNode(targetData.rowid);
                if (!isEmpty(targetRowNode)) {
                    targetRowNode.setData({ ...targetData });
                    setTimeout(() => storeRowData(panel), 0);
                    return;
                }
            }
        }
        dispatch(entrydata({ ...targetData }));
        dispatch(entryrerender());
    }
    function loadColorMasterInfo(colorCode, options) {
        const requestOptions = isEmpty(options) ? {} : options;
        const requestColorCode = String(isEmpty(colorCode) ? "" : colorCode).trim();
        const targetData = isEmpty(DicVal(requestOptions, "targetData", null))
            ? entrydataRef.current
            : DicVal(requestOptions, "targetData", null);
        const rowNode = DicVal(requestOptions, "rowNode", null);
        const panel = DicVal(requestOptions, "panel", null);
        if (isEmpty(targetData)) return;
        if (isEmpty(requestColorCode)) {
            const cleared = clearColorMasterInfoOnData(targetData);
            if (!cleared) return;
            reflectColorMasterInfoChange(targetData, rowNode, panel);
            return;
        }

        const source = {
            ...(isEmpty(entrydataRef.current) ? {} : entrydataRef.current),
            ...(isEmpty(targetData) ? {} : targetData)
        };
        const brandCode = String(resolveItemMasterBrandCode(source)).trim();
        if (isEmpty(brandCode)) {
            const cleared = clearColorMasterInfoOnData(targetData);
            if (!cleared) return;
            reflectColorMasterInfoChange(targetData, rowNode, panel);
            return;
        }

        fnc.current.postaxios("hinbanmaster/GetColorMasterInfo",
            { BrandCode: brandCode, ColorCode: requestColorCode },
            {
                onSuccess: function (data) {
                    let changed = false;
                    if (String(DicVal(data.returnData, "Found", "false")).toLowerCase() === "true") {
                        changed = applyColorMasterInfoToData(targetData, data.returnData);
                    } else if (DicVal(requestOptions, "clearOnNotFound", true)) {
                        changed = clearColorMasterInfoOnData(targetData);
                    }
                    if (!changed) return;
                    reflectColorMasterInfoChange(targetData, rowNode, panel);
                },
                onError: function (data) {
                    if (!DicVal(requestOptions, "silent", true)) {
                        let msg = "カラー情報の取得に失敗しました";
                        if (!isEmpty(data.errDescription)) msg = data.errDescription;
                        fnc.current.warnmsg(msg);
                    }
                }
            }, true
        );
    }

    return {
        applyColorMasterInfoToData,
        clearColorMasterInfoOnData,
        reflectColorMasterInfoChange,
        loadColorMasterInfo
    };
}
